export const headerName = {
  routeConstant: 'service-requests/v6',
  routeConstantv7: 'service-requests/v7',
  readOnlyUser: 'READ_ONLY',
  serviceInformation: 'Service information',
  serviceDetails: 'Service details',
  agreementDetails: 'Agreement details',
  generalInformation: 'General information',
  configurationSettings: 'Settings',
  strategicNeedToMakeChange: 'Need to make a change?',
  createRequestButton: 'Create request',
  tryAgain: 'Try again',
  apnSessionStorageName: 'apnSessionStorageName',
  Manage: 'Manage',
  cancel: 'Cancel',
  save: 'Save',
  edit: 'Edit',
  next: 'Next',
  break: 'Break',
  refresh: 'Refresh',
  mobileServiceDetailPageCreateRequestButtonLabel: 'Create a request',
  apnAdd: 'Add APN',
  apnRemove: 'Remove APN',
  apnRemoveUserEnter: 'Enter an APN',
  apn: 'Access Point Name (APN)',
  voicemailSessionStorageName: 'voicemailSessionStorageName',
  incorrectMobileServiceContractEndDate: '2999-12-31',
  reacSessionStorageName: 'reacSessionStorageName',
  deacSessionStorageName: 'deacSessionStorageName',
  yourServiceRefBlockLabel: 'Your service reference',
  needToMakeChange: 'Need to make another type of change?',
  iDDSessionStorageName: 'iDDSessionStorageName',
  submit: 'Submit',
  enableIntRoamModalHeader: 'Enable international roaming',
  disableIntRoamModalHeader: 'Disable international roaming',
  proceedToIntRoaming: (buttonName: string) => `Proceed to ${buttonName} roaming`,
  cancelEnableRoaming: 'Cancel enabling roaming',
  ourCustomerTerms: 'Our Customer Terms',
  intRoamEligibleCountries: 'eligible countries',
  intRoamSessionStorageName: 'intRoamSessionStorage',
  leavingTConnectPageModalHeader: "You're now leaving Telstra Connect",
  messaging: 'Messaging',
  enableMMSModalHeader: 'Enable MMS',
  cancelEnableMMS: 'Cancel enabling MMS',
  proceedEnableMMS: 'Proceed to enable MMS',
  mmsSessionStorageName: 'mmsSessionStorageName',
  mmsTitle: 'Multimedia Messaging Service (MMS)',
  reactivateWithinDueDateCatItemKey: 'reactivate-within-due-date',
  mobilitySolutions: 'mobility-solutions',
  dashboard: 'Dashboard',
  networksAndInternet: 'Networks and internet',
  serverErrorText: 'Server Error',
  mobile_plans_devices: 'Mobile plans and devices',
  trackRequests: 'Track requests',
  yourServices: 'Your services',
  manage: 'Manage',
  services: 'Services',
  searchMobileNumberLabel: 'Search mobile number',
  combinedSearchLabel: 'Find in table',
  maximGeneralForm: 'General request form',
  mobileServicesFormName: 'Mobile services',
  requestId: 'Request ID ',
  billingAccountNumber: 'Billing account number',
  billingNumber: 'Billing number',
  usageSummary: 'Usage summary',
  summary: 'Summary',
  groupName: 'Group name',
  offerName: 'Offer name',
  groupId: 'Group ID',
  offerId: 'Offer ID',
  sharedDataUsage: 'Shared data usage',
  australianSharedDataUsage: 'Australian shared data usage',
  australianDataUsage: 'Australian data usage',
  dataUsageDetails: 'Data usage details',
  srmBaseUrl: '/app/service-requests/',
  maximFormUrl: '/app/service-requests/mobile-services/maxim-form',
  mobileChangeRequestUrl: '/app/service-requests/mobile-services-request-form',
  tickIconForSave: 'icon-system-ui-tick',
  loadingIconForSave: 'icon-system-loading',
  addYourReference: 'Add your reference',
  nicknameAssistiveText:
    'This reference should not exceed 80 characters, nor contain special characters.',
  somethingWentWrong: 'Something went wrong. Try again',
  serviceStatus: 'Service status',
  statusDisconnected: 'Disconnected',
  statusSuspended: 'Suspended',
  statusPending: 'Pending',
  statusActive: 'Active',
  activationStatus: 'Processing activation',
  directoryListing: 'Directory listing',
  enterKeyCode: 13,
}

export const messages = {
  noDataAvailable: 'No data available',
  strategicDeviceDetailsBanner: "We're working on some updates to this screen.",
  somethingWentWrong: 'Something went wrong!',
  apnPendingAdding: 'Pending - Adding APN/s',
  apnPendingRemoving: 'Pending - Removing APN/s',
  staffTooltip: 'Telstra staff cannot make this change.',
  requiredField: 'This field is required',
  apnActiveDefault: 'Activate a default APN to access data',
  optionSelect: 'Select an option',
  apnGenericAlertMsg: 'This may not be the full list of available APN',
  removeAPNWarning:
    'Removing this APN may leave this service without some or all access to data-driven features.',
  apiCallError: 'Oops – something went wrong. Try again.',
  apnRadioButtonSelectionErrorMessage: 'You must select an option to continue',
  apnAssistiveText: 'The network path for data connectivity',
  apnSuccessMsg: 'Your APN request has been submitted',
  voicemailNotEligibleAlertMsg: `This is a data-only plan. If you'd like to add MessageBank®,
  you'll need to upgrade to a voice and data plan.`,
  modalServerError:
    'The server was unable to complete your request.' +
    ' Please try again. If that does not fix it, please report this error.',
  alertTextForMobileServiceDetailPage: `Changes made to this mobile
  service can take up to 24 hours to be updated on this screen.`,
  alertTextForMigratedMobileServiceDetailPage: `This mobile service was recently migrated to our new
  Adaptive Mobility network. More details for this service are available under
  Billing and Networks and internet. `,
  alertTextForMigratedMobileServiceDetailPageNewLine: `Changes made to this mobile service can
  take up to 24 hours to be updated on this screen.`,
  activeEmptyServieReference: 'No reference applied. Create a request to add one.',
  nonActiveEmptyServiceReference: 'No reference applied when service was last active.',
  yourServiceReferenceTooltipText:
    'Your reference, for your records. ' +
    'This reference will also display on invoices and elsewhere on Telstra Connect.',
  iddDisablePending: 'Pending disabling international calls',
  iddEnablePending: 'Pending enabling international calls',
  iddEnableAdaptivePending: 'Pending enabling international calls for adaptive mobility',
  iddAdaptiveInfo1: 'This pack will only help while in Australia to make international calls.',
  iddAdaptiveInfo2: 'This pack will not help while overseas without international roaming enabled.',
  iddSuccessMsg: 'Your international calling request has been submitted',
  iddNonEligibleText:
    "This is a data-only plan. If you'd like to add International calling, " +
    "you'll need to upgrade to a voice and data plan.",
  iddToolTip: `If you're going overseas, for international calls and SMS to work, you will also need to enable international roaming.`,
  tempSuspDiversionHeader: `Forward calls to the following number while this mobile number is suspended:`,
  tempSuspensionDiversionNumberText: `Invalid entry. Mobile number must begin with '04' and be 10 digits.`,
  tempSuspToastMessage: 'Your temporary suspension request has been submitted.',
  deacToastMessage: 'Your deactivation request has been submitted.',
  reacToastMessage: 'Your reactivation request has been submitted.',
  disableIntRoamModalDescription:
    'If you also have international calls enabled, please disable them under ‘Calling’.',
  intRoamLinkURL: 'https://www.telstra.com.au/support/mobiles-devices/international-roaming',
  serviceTermsUrl: 'https://www.telstra.com.au/customer-terms/digitalterms',
  supportEnquiryUrl: 'https://connectapp.telstra.com/app/customer-support/new-enquiry',
  customertermsLinkURL:
    'https://www.telstra.com.au/customer-terms/business-government#telstra-mobile',
  mobileServiceintRoamVisibleAlertMessage:
    'You will need to enable to make calls and use data while overseas',
  mobileServiceintRoamHiddenAlertMessage: ' about inclusions, eligible countries and charges',
  mobileServiceintRoamEnabledAlertMessage:
    'To make calls while overseas, please ensure international calls and SMS (see below) are also enabled before leaving Australia.',
  mobileServiceintRoamEnabledAlertMessageWithCalling: " See 'Calling' below.",
  intRoamSubmissionSuccessToastMessage: 'Your international roaming request has been submitted.',
  leavingTConnectPageModalMessage:
    'Your Telstra Connect session times out after 15 minutes of no activity,' +
    "so if you're gone for a while you will need to sign back in.",
  mmsPendingEnabling: 'Pending - Enabling MMS',
  mmsPendingDisabling: 'Pending - Disabling MMS',
  mmsNotEligibleAlertMsg:
    "This is a data-only plan. If you'd like to add MMS, " +
    "you'll need to upgrade to a voice and data plan.",
  mmsSuccessMsg: 'Your MMS request has been submitted',
  manageServicesMessage:
    `To make changes to a mobile service(s), select from the menu options under 'Manage' ` +
    `at right below. For other requests, select 'New request' below. We're making regular updates to this screen, ` +
    `so keep an eye out for new features.`,
  adaptiveMobilitymanageServicesMessage: `To make changes to a mobile service(s), select from the menu
  options under ‘Manage’ at right below. We’re making regular updates to this screen, so keep an eye out
  for new features. For all Adaptive Mobility or Corporate Mobile Plus services, select ‘Manage’ below.`,
  anotherRequest: 'New request',
  submissionSuccessToastMessage: (
    serviceNumber: string,
  ) => `Your request for ${serviceNumber} will be updated
    under its status below in the next few minutes.`,
  noMobileServices: 'There are currently no mobile services',
  adaptiveMobilityTooltipText: `Services include:

        Adaptive Mobility

        - Mobile Essential, Enhance and Epic

        - Mobile Broadband Essential,
        Enhanced and Epic

        - Enterprise Wireless Epic

        Corporate Mobile Plus

        Mobile and Broadband Local, National
        and Global plans with the option to
        BYO devices from us.`,
  viewRequest: 'View all requests',
  nicknameErrorMessage:
    'This reference should not exceed 80 characters, nor contain special characters.',
  nickNameStrategicErrorMessage:
    'Invalid entry. Please use letters and numbers and up to 80 characters',
  nicknameSuccessMessage: 'Your service reference for has been updated.',
  statusDisconnected: 'This service has been disconnected or is no longer in service.',
  statusPending: 'This can take up to 24 hours to be completed.',
  supportEnquiry: {
    enquiryMessage: 'If this status does not seem right to you, please ',
    enquiryUrl: '/app/customer-support/new-enquiry',
    enquirySubmit: 'submit a support enquiry',
  },
  directoryListingTooltipContent: {
    content: `Phone numbers and owner details are still accessible to critical government users 
    such as Triple Zero, Emergency Alert, law enforcement and national security agencies.
    For details about the Australian Communications and Media Authority\'s Integrated Public Number Database visit`,
    url: 'https://www.acma.gov.au/accessing-ipnd.',
  },
  noReferenceApplied: 'No reference applied',
  etcToolTip: `If today you wish to deactivate this service or pay out a
     product associated with it that is subject to an ETC, you will be charged the total estimate displayed.`,
  serviceStatusDiscrepancy:
    'It looks like this service has been changed in the last 24 hours' +
    'e.g. it might have been deactivated or suspended.' +
    '\n The new Early Termination Charge can take up to 24 hours to display.' +
    '\n Please try again later.',
  etcError: 'Something went wrong',
}

export const mobileServicesDetailPageSIMSerialMessages = {
  assistiveText: 'Enter 13-digit serial number. Must start with 7, 8 or 9.',
  lessThanThirteenInput: '13 digits required.',
  sameSIMSerialNumberInput: 'Please enter a different SIM serial to the existing one.',
  inputOtherThanRequriedStartingNumber: 'Serial number must start with 7, 8 or 9.',
  requestInProgressInfoMessage: 'Select refresh for any status updates',
  simSerialRedirectionModalContent: "If you continue, you'll lose your changes",
  simSerialRedirectionModalHeader: "You're about to go to a new screen",
  simSerialRequestSubmittedToastContent:
    'Your SIM replacement request will take up to one business day to be updated',
}

export const strategicCatalogues = [
  'Adaptive Mobility - SIM Replacement (New SIM)',
  'SIM Replacement (New SIM)',
  'Resume Mobile Service',
  'Suspend Mobile Service',
  'Access Point Name (APN) – select, change or remove',
  'Manage Telstra One Number',
]

export const maximFormConfigObject = {
  voice2TextMessageBank: {
    questionsHeader: "Leave your details below and we'll contact you about options if needed:",
  },
  changeToVideoMessageBank: {
    questionsHeader:
      "Leave your details below and we'll contact you about mobile or data plan options.",
  },
  enableVideoMessageBank: {
    questionsHeader:
      "Leave your details below and we'll contact you about mobile or data plan options.",
  },
}

export const modifyDiversionModalMessages = {
  header: 'Add or change call forwarding to the temporarily suspended service',
  intro: 'This will restart your 28-day temporary suspension on this service.',
  costDetails:
    "To retain your number you'll be charged $5.50* per month or part thereof plus $5.50* pro rata" +
    ' for the time your service has already been suspended.',
  subText:
    'If this service is reactivated, the call forwarding you set up now will also be removed and any' +
    ' pre-suspension settings will be restored.',
  conditions: '*Includes GST',
}

export const enableIntRoamModalMessages = {
  needToMakeCalls: `Need to make calls while overseas? When international roaming is enabled, you will need to
  ensure international calls and SMS are also enabled on this mobile before leaving Australia.`,
  enablingIntRoam: `Enabling international calls and SMS removes any call barring that might be in place.`,
  dataUsageOverseas: `If you are concerned about high data usage while overseas, turn off mobile data roaming
  via the settings on the mobile device. This will override any mobile data roaming settings.`,
  enableIntRoamRadioOptionsHeader: 'What would you like to do?',
  enableIntRoamRadioFastChange:
    'Activate international roaming on the current mobile service plan,' +
    'which may include pay-as-you-go call and data rates.',
  enableIntRoamRadioMaxim:
    'To save on roaming costs, we can help you with the right international roaming pass.',
  intRoamCheckboxText:
    'I have read and understood all of the above and agree to enable international roaming.',
  stpGeneralAlertMessage:
    'If you need to make calls and send SMS while overseas, please ensure' +
    ' international calls and SMS is enabled before leaving Australia.',
  radioButtonSelectionErrorMessage: 'You must select an option to continue',
  userAgreementCheckErrorMessage: 'You must agree to this to continue',
}

export const enableMMSModalMessages = {
  descHeader: 'MMS requires data and data barring to be removed',
  desc1: `For MMS to work, this service needs data access. If this service is not on a plan,
  pay-as-you-go data rates may apply.`,
  desc2: `If data barring is enabled on this service, we will remove it so that MMS can work.`,
  desc3: `To curb high mobile data usage, turn off mobile data in the phone's settings.`,
  radioOptionsHeader: 'What would you like to do?',
  radioButtonSelectionErrorMessage: 'You must select an option to continue',
  enableRadioFastChange: 'Enable MMS and remove any data barring',
  enableRadioMaxim:
    'Enable MMS, remove any data barring and request help with mobile or data plan options',
  stpGeneralAlertMessage: `Before proceeding with the change, remember: If this service is not on a plan,
  pay-as-you-go data changes may apply.`,
  agreementCheckboxText: `I agree to data being used for this service and any pay-as-you-go charges that may occur.`,
  userAgreementCheckErrorMessage: 'You must agree to this to continue',
  questionsHeader: `Leave your details below and we'll contact you about mobile or data plan options.`,
}
export const mobileServicesFastChangeRequestCardData = {
  request: {
    id: headerName.reactivateWithinDueDateCatItemKey,
    header: 'Request',
    p1: 'Trackable with reference #',
    p2: 'Takes up to one business day',
  },
  fastChange: {
    id: 'reactivate-fastChange',
    header: 'Fast change',
    p1: 'Not trackable',
    p2: 'Takes up to a few minutes',
  },
}
